import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay,isFunction } from '../../../../utils/utils';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import JourneyCustomerCard from './JourneyCustomerCard';
import JourneyTripLRCard from './JourneyTripLRCard';
import JourneyTripMaterialCard from './JourneyTripMaterialCard';
import JourneyTripRouteCardWithRouter from './JourneyTripRouteCard';
import JourneyTripKmsCard from './JourneyTripKmsCard';
import JourneyTripTimeline from './JourneyTripTimeline';
import JourneyTripActionCard from './JourneyTripActionCard';
import JourneyTripFreightCard from './JourneyTripFreightCard';
import JourneyTripPendingBalanceCard from './JourneyTripPendingBalanceCard';
import JourneyTripAdvanceCard from './JourneyTripAdvanceCard';
import JourneyTripChargesCard from './JourneyTripChargesCard';
import JourneyTripPaymentsCard from './JourneyTripPaymentsCard';
import JourneyTripNotesCard from './JourneyTripNotesCard';
import JourneyTripTruckHireCostCard from './JourneyTripTruckHireCostCard';
import JourneySupplierCard from './JourneySupplierCard';
import JourneyTripSupplierAdvanceCard from './JourneyTripSupplierAdvanceCard';
import JourneyTripSupplierChargesCard from './JourneyTripSupplierChargesCard';
import JourneyTripSupplierPaymentsCard from './JourneyTripSupplierPaymentsCard';
import JourneyTripSupplierPendingBalanceCard from './JourneyTripSupplierPendingBalanceCard';
import AddEditLoadSideBar from '../../../components/Trip/AddEditLoadSideBar';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    backgroundColor:'#fff',
    borderRadius:4,
  },
  topSection:{
    display:'flex',
    width:'100%',
    justifyContent:'space-between',
    alignItems:'center',
  },
  addLoadDiv:{
    backgroundColor:'#fafafa',
    paddingRight:16,
    paddingLeft:16,
    padding:12,
  },
  addLoadButton:{
    marginRight:16,
    width: '100%',
    padding:'4px 16px',
    backgroundColor: '#fff',
    textTransform: 'capitalize',
    color: '#00875a',
    fontWeight: 600,
    borderRadius: 8,
    fontSize:14,
    border: 'solid 1px #00875a',
    '&:hover': {
      backgroundColor: '#fff'
    }
  }
}));
const AntTabs = withStyles({
  root: {
    backgroundColor:'#fafafa',
    borderRadius:4,
    //width:'90%'
    //borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    display:'none'
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    backgroundColor:'#fafafa',
    minWidth: 137,
    borderRadius:4,
    color: '#0b1323',
    fontWeight:600,
    fontSize:16,
    boxShadow:'0 4px 4px 0 rgba(0, 0, 0, 0.25)',
    padding:16,
    opacity:'unset',
    //marginRight: theme.spacing(4),
    '&:first-of-type': {
      borderBottomLeftRadius:0,
      borderTopLeftRadius:0,
    },
    '&:last-of-type': {
      borderBottomRightRadius:0,
      borderTopRightRadius:0,
    },
    '&:hover': {
      color: '#0b1323',
      opacity: 1,
    },
    '&$selected': {
      color: '#0b1323',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor:'#fff',
      boxShadow:'none',
      fontWeight:600,
      borderBottomLeftRadius:0,
      borderBottomRightRadius:0,
    },
    '&:focus': {
      color: '#0b1323',
    },
  },
  wrapper: {
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />);
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const JourneyTripsTabs = (props) => {
  const {journey,updateJourney,onTripTabChange,activeTab} = props;
  const classes = useStyles();
  let history = useHistory();
  const [tab, setTab] = React.useState(activeTab);
  const [addEditTripSideBarOpen, setAddEditTripSideBarOpen] = useState(false);
  let hiredTrip = journey && journey.vehicle && journey.vehicle.ownershipType && journey.vehicle.ownershipType == 'HIRED' ? true : false;
  let lastTrip = journey && journey.trips && journey.trips.length>0?journey.trips[journey.trips.length-1]:null
  const handleTabChange = (event, newValue) => {
    if(onTripTabChange && isFunction(onTripTabChange)){
      onTripTabChange(newValue);
    }
  };
  const handleAddEditTripSideBarClose = (create) => {
    setAddEditTripSideBarOpen(false);
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
  };
  const handleAddEditTripSideBarConfirm = (create) => {
    setAddEditTripSideBarOpen(false);
    let tripLength = journey && journey.trips && journey.trips.length>0?journey.trips.length:null
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
      onTripTabChange(tripLength);
    }
  };
  const handleAddLoad = ()=>{
    if (isFunction(updateJourney) && journey.id) {
      updateJourney(journey.id)
    }
    setAddEditTripSideBarOpen(true)
  }
  return (
    <>
      <div className={classes.card}>
        <div className={classes.topSection}>
          <AntTabs value={activeTab} style={{width:hiredTrip?'100%':'90%'}} onChange={handleTabChange} aria-label="Trips tab">
            {journey && journey.trips && journey.trips.map((trip,index)=>{
                return <AntTab label={trip && trip.customer && trip.customer.customerName? trip.customer.customerName:''} {...a11yProps(index)} />
            })}
          </AntTabs>
          {!hiredTrip && <div className={classes.addLoadDiv}>
            <Button className={classes.addLoadButton} onClick={handleAddLoad} variant="outlined">
              <AddIcon style={{fontSize:14,fontWeight:600}} />Add Load
            </Button>
          </div>}
        </div>
        {journey && journey.trips && journey.trips.map((trip,index)=>{
              return <TabPanel value={activeTab} index={index}>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <JourneyCustomerCard updateJourney={updateJourney} customer={trip && trip.customer? trip.customer:''} amount={trip && trip.balanceAmount? trip.balanceAmount:''} />
                    </Grid>
                    {hiredTrip?<>
                      <Grid item xs={6}>
                          <JourneySupplierCard 
                            updateJourney={updateJourney} 
                            supplier={journey && journey.vendor? journey.vendor:''} 
                          />
                      </Grid>
                    </>
                    :null}
                    <Grid item xs={3}>
                        <JourneyTripLRCard updateJourney={updateJourney} number={trip && trip.lrNumber? trip.lrNumber:''}  />
                    </Grid>
                    <Grid item xs={3}>
                        <JourneyTripMaterialCard updateJourney={updateJourney} material={trip && trip.material? trip.material:''} />
                    </Grid>
                    <Grid item xs={6}>
                      <JourneyTripRouteCardWithRouter
                        updateJourney={updateJourney}
                        destination={trip.destinationLocation ? trip.destinationLocation : ''}
                        source={trip.startLocation ? trip.startLocation : ''}
                        startDate={trip.startDate ? trip.startDate : ''}
                        completedDate={trip.completedDate ? trip.completedDate : ''}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <JourneyTripKmsCard
                        updateJourney={updateJourney}
                        start={trip.startOdometerReading ? trip.startOdometerReading : ''}
                        end={trip.endOdometerReading ? trip.endOdometerReading : ''}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <JourneyTripTimeline updateJourney={updateJourney} trip={trip} />
                    </Grid>
                    <Grid item xs={12}>
                      <JourneyTripActionCard selectedTrip={trip} journey={journey} updateJourney={updateJourney}/>
                    </Grid>
                    <Grid item xs={12}>
                      <JourneyTripFreightCard  trip={trip} journey={journey} updateJourney={updateJourney}/>
                      <JourneyTripAdvanceCard trip={trip} journey={journey} updateJourney={updateJourney}/>
                      <JourneyTripChargesCard trip={trip} journey={journey}  updateJourney={updateJourney}/>
                      <JourneyTripPaymentsCard trip={trip} journey={journey} updateJourney={updateJourney}/>
                      <JourneyTripPendingBalanceCard trip={trip} journey={journey} updateJourney={updateJourney}/>
                    </Grid>
                    {hiredTrip?<>
                      <Grid item xs={12}>
                          <JourneyTripTruckHireCostCard trip={trip} journey={journey} updateJourney={updateJourney} />
                          <JourneyTripSupplierAdvanceCard trip={trip} journey={journey} updateJourney={updateJourney}/>
                          <JourneyTripSupplierChargesCard trip={trip} journey={journey} updateJourney={updateJourney}/>
                          <JourneyTripSupplierPaymentsCard trip={trip} journey={journey} updateJourney={updateJourney} />
                          <JourneyTripSupplierPendingBalanceCard trip={trip} journey={journey} updateJourney={updateJourney} />
                      </Grid>
                    </>
                    :null}
                    <Grid item xs={12}>
                      <JourneyTripNotesCard selectedTrip={trip} journey={journey} updateJourney={updateJourney}/>
                    </Grid>
                  </Grid>
            </TabPanel>
        })}
      </div>
      {addEditTripSideBarOpen && <AddEditLoadSideBar addLoad={true} lastTrip={lastTrip} journey={journey} selectedTrip={null} updateJourney={updateJourney} sideBarTitle="Add Load" sideBarOpen={addEditTripSideBarOpen} onAddLoad={handleAddEditTripSideBarConfirm} sideBarClose={handleAddEditTripSideBarClose} tripId={null} />}
    </>
  );
}
export default JourneyTripsTabs;